module.exports = __webpack_public_path__ + "media/images/emblems/Moiry-coat_of_arms-23cd037a7217f632d09eb5a34944ee23.svg";